@if (ppLabels.length === 0) {
  <div class="assetCard__noLabels assetCard__noLabelsText">
    {{ 'asset_no_labels' | ppTranslate }}
  </div>
}

@if (ppLabels.length > 0) {
  <div class="assetCard__labelContainer">
    @for (label of ppLabels; track label) {
      <pp-asset-card-information-label
        [ppLabel]="label"
      ></pp-asset-card-information-label>
    }
  </div>
}
